module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('sk-panel', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', {
    staticClass: "booking-successful"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket"
  }, [_c('sk-title-heading', {
    attrs: {
      "h2": "",
      "label": "Payment Status"
    }
  }), _vm._v(" "), _c('p', [_vm._v("We're sorry, but this payment could not be processed. Please contact your financial institution and try again or use a different card. ")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "sm10": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket--right"
  }, [_c('div', {
    staticClass: "movie-details"
  }, [(_vm.error != undefined) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.errorDescription != undefined),
      expression: "error.errorDescription != undefined"
    }],
    staticClass: "confirmation-error"
  }, [_c('p', [_vm._v(_vm._s(_vm.error.errorDescription))])])] : _vm._e(), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "inline-block": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("\n                                                Cancel Booking\n                                            ")]), _vm._v(" "), (_vm.order != undefined) ? [_c('sk-button', {
    attrs: {
      "primary": "",
      "inline-block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.returnToBookingFlow()
      }
    }
  }, [_vm._v("\n                                                    Try Again\n                                                ")])] : _vm._e()], 2)])])], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('sk-signin'), _vm._v(" "), _c('sk-related-movies', {
    attrs: {
      "movies": _vm.related_movies
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349015b1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/booking-unsuccessful/booking-unsuccesful.vue
// module id = 755
// module chunks = 0